import React, { useEffect, useState } from 'react';
import { usePhoneNumberValue } from '@/hooks/tab';
import { useClientPhoneNumber } from '@/hooks/client';
import { useCurrentPhoneNumberItem } from '@/hooks/reference';
import { ClientTab } from '@/types/common';
import { ClientView } from '@/components/organisms/sidebar/Common';
import { formatPhoneNumber } from '@/utilities/client';

const View: React.FC = () => {
  const [clientTab, setClientTab] = useState(ClientTab.BOUGHT);
  const [tabs, setTabs] = useState([clientTab]);
  const [inputValue] = usePhoneNumberValue();
  const [currentItem, setCurrentItem] = useCurrentPhoneNumberItem();
  const data = useClientPhoneNumber(formatPhoneNumber(inputValue));

  useEffect(() => {
    if (!tabs.includes(clientTab)) {
      setTabs([...tabs, clientTab]);
    }
  }, [clientTab]);

  return (
    <ClientView
      isEmailTab={false}
      isPhoneTab={true}
      inputValue={`#${inputValue}`}
      clientTab={clientTab}
      clientTabs={tabs}
      setClientTab={setClientTab}
      setCurrentItem={setCurrentItem}
      currentItem={currentItem}
      data={data}
    />
  );
};

export default View;
